import { Component, OnInit, Input, ViewEncapsulation, ViewContainerRef, NgModule, Compiler, ViewChild } from '@angular/core';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { Footer } from '../interfaces/footer.interface';
import { CommonService } from '../services/common.service';
import { IContent } from '../interfaces/content.interface';
import { StoreConfig } from '../interfaces/store-config.interface';
import { ConfigurationService } from '../services/configuration.service';
import { MemberType } from '../../shared/enums/member-type.enum';
import { MemberLevel } from '../../shared/enums/member-level.enum';
import { MenuPortal } from '../../shared/enums/menu-portal.enum';
import { MenuItem } from '../../shared/interfaces/menu-item.interface';
import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { RoutePath } from '../enums/route-path.enum';
import { DynamicRoute, TranslateParam } from '../../common/interfaces';

@Component({
  selector: 'app-footer',
  templateUrl: '../templates/template1/views/app-footer.component.html',
  styleUrls: ['../templates/template1/themes/default/less/app-footer.less'],
  encapsulation: ViewEncapsulation.None
})
export class AppFooterComponent implements OnInit {
  //  cms inputs
  @Input() placeHolderName: string;
  @Input() sitemapNodeName: string;
  @ViewChild('DynamicHtmlContent', { read: ViewContainerRef, static: false }) container: ViewContainerRef;
  public footerData: any = {};
  private isoCountryCode: string;
  languageCode: string;
  translateParams: TranslateParam;
  contenthtml: any = '';
  store: StoreConfig;
  appSites: MenuItem[];
  portalID: number;


  constructor(private _commonService: CommonService,
    private _cacheService: CacheService,
    private compiler: Compiler,
    private _localStorageService: LocalStorageService,
    private _router: Router,
    private _configurationService: ConfigurationService) { }

  ngOnInit() {
    this.getStoreData();
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.subscribeMenu();
  }

  /**
 * get store data from localstorage
 */
  getStoreData(): void {
    const storeData: StoreConfig = this._configurationService.getStoreData();
    if (storeData) {
      this.store = storeData;
    }
  }

  /**
  * To get footer data from cms
  */
  subscribeMenu(): void {
    const store: StoreConfig = this._configurationService.getStoreData();
    const countryId: number = this._cacheService.getCookieValue(CacheKey.CountryId);
    const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
    let memberTypeId;
    const userBasicInfo: any = this._localStorageService.get('userInfo');
    if (userBasicInfo) {
      memberTypeId = userBasicInfo.memberTypeId === MemberType.DISTRIBUTOR ? MemberLevel.PREFERREDCUSTOMER : MemberLevel.RETAIL;
    } else {
      memberTypeId = MemberLevel.RETAIL;
    }
    this.portalID = MenuPortal.Corporate;
    if (store && store.id && countryId) {
      this._commonService.getApplicationSites(this.portalID, store.id, countryId, languageCode, memberTypeId)
        .subscribe(sites => {
          if (sites && sites.length > 0) {
            this.appSites = sites;
            this.getContent();
          }
        });
    }
  }

  loadCmsData(sitemapId: number): void {
    const store: StoreConfig = this._configurationService.getStoreData();
    if (store && store.id && sitemapId) {
      this._commonService
        .getCMSContentBySiteMapId(sitemapId, store.homeIsocodeThree, store.id, this.portalID)
        .subscribe((response: any) => {
          if (response.pageContent) {
            this.contenthtml = response.pageContent;
          }
        }, (error: any) => {
          this.translateParams = this._commonService.handleError(error);
        });
    }
  }

  getContent() {
    const menus = this.appSites;
    let obj: any;
    const footerslug = 'footer';
    const menu = menus.find((item: MenuItem) => item.slug === footerslug);
    if (menu && menu.siteMapId) {
      this.loadCmsData(menu.siteMapId);
    }
    // let sitemapId = null;
    // obj = _(menus)
    //   .thru(function (coll: any) {
    //     return _.union(coll, _.map(coll, 'childs'));
    //   })
    //   .flatten()
    //   .find({ slug: footerslug });
    // if (obj) { sitemapId = obj.siteMapId; }
    // if (sitemapId) {
    //   this.loadCmsData(sitemapId);
    // }
  }

  /**
   * Navigate to forever living faq
   *
   * @param {string} route
   * @memberof AppFooterComponent
   */
  navigateToRoute(dynamicRoute: DynamicRoute): void {
    if (dynamicRoute) {
      let isAppRoute = this.checkAppRoute(dynamicRoute.route);
      let routes = dynamicRoute.route.split('/');
      if (environment.betaPortal) {
        let skipNavigation = this._commonService
          .checkSkipNavigation(this.isoCountryCode.toLowerCase());
        if (skipNavigation) {
          this.navigateToPreviewPage(routes);
          return;
        }
        else {
          let betaUrl = this._commonService.constructBetaUrl(dynamicRoute.route);
          routes = betaUrl.split('/');
        }
      }
      if (routes && routes.length > 3 && !this.routeURLHasExtension(dynamicRoute.route) && isAppRoute && this.checkAppRouteExlusion(routes[2])) {
        const route = routes[0] + '//' + routes[2] + '/'
          + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/' + routes[3];
        window.open(route, dynamicRoute.target);
      } else {
        window.open(dynamicRoute.route, dynamicRoute.target);
      }
    }
  }

  /**
   * @description this method will find the url have extension or not
   * @date 2019-04-27
   * @private
   * @param {*} url
   * @returns {boolean}
   * @memberof AppFooterComponent
   */
  private routeURLHasExtension(url): boolean {
    // Extension starts after the first dot after the last slash
    const extStart = url.split(/[?#]/)[0].indexOf('.', url.lastIndexOf('/') + 1);
    if (extStart === -1) {
      return false;
    }
    const ext = url.substr(extStart + 1);
    // end of extension must be one of: end-of-string or question-mark or hash-mark
    const extEnd = ext.search(/$|[?#]/);
    const extension = ext.substring(0, extEnd);
    return extension ? true : false;
  }

  /**
   * @description
   * @date 2019-07-24
   * @param {string[]} url
   */
  navigateToPreviewPage(url: string[]): void {
    let slug: string;
    if (url && url.length) {
      slug = url[url.length - 1];
      slug = slug.indexOf('?') > -1 ? slug.split('?')[0] : slug;
      this._router.navigate(['./' + this.isoCountryCode.toLowerCase()
        + '/' + this.languageCode.toLowerCase() + '/' + slug]);
    }
  }
  /**
  * @description To check our site or not
  * @author saravanan
  * @date 2019-10-23
  * @private
  * @param {string} url
  * @returns {boolean}
  * @memberof AppFooterComponent
  */
  private checkAppRoute(url: string): boolean {
    if (url.indexOf(environment.cookieDomain.substr(1)) > -1) {
      return true;
    }
    return false;
  }

  /** 
   * @description To check whether redirecting url is aklso having same domain name
   * @param {string} hostname
   * @returns {boolean}
   * @memberof AppFooterComponent
  */
  private checkAppRouteExlusion(hostname: string): boolean {
    var urlexclusions = environment.urlexclusions.split(",");
    if(urlexclusions.includes(hostname)){
      return false;
    }
    return true;
  }

}
